module.exports = {
  trackingId: 'UA-123456789'
};
